/*
 * Motion layer, ported from src/components/Motion.tsx.
 * - Tags elements itself, so section markup stays clean.
 * - Reveal styles apply only once .motion-ready is on <html>: with JS off every
 *   element stays visible (nothing hidden from crawlers or readers).
 * - Skipped outright under prefers-reduced-motion.
 * - Figures count up to their real value; the nav gains a shadow on scroll.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var REVEAL_GROUPS = [
    '.hero-inner > *',
    '.hero-content > *',
    '.hero-proof > *',
    '.band-content > *',
    '.close-grid > *',
    '.mosaic > *',
    '.trust-strip > li',
    '.section-head',
    '.grid > *',
    '.spec-wrap',
    '.money > *',
    '.cta-band > *',
    '.checks > li',
    '.pills > li',
    '.hero-stats > *',
    '.split > *',
    '.foot-grid > *',
  ];

  var root = document.documentElement;
  root.classList.add('motion-ready');

  var targets = [];
  REVEAL_GROUPS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', '');
      targets.push(el);
    });
  });

  // Stagger siblings so a grid cascades instead of popping as one block.
  var byParent = new Map();
  targets.forEach(function (el) {
    var p = el.parentElement;
    if (!p) return;
    var list = byParent.get(p) || [];
    list.push(el);
    byParent.set(p, list);
  });
  byParent.forEach(function (list) {
    list.forEach(function (el, i) {
      el.style.setProperty('--i', String(Math.min(i, 8)));
    });
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  targets.forEach(function (el) {
    io.observe(el);
  });

  // Count up the figures: animate the one number, leave prefix/suffix alone.
  var counters = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        counters.unobserve(el);
        var text = el.textContent || '';
        var m = text.match(/^(\D*?)(\d+)(\D*)$/);
        if (!m) return;
        var target = parseInt(m[2], 10);
        if (!isFinite(target) || target === 0) return;
        var dur = 900;
        var start = performance.now();
        var tick = function (now) {
          var t = Math.min(1, (now - start) / dur);
          var eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
          el.textContent = m[1] + Math.round(target * eased) + m[3];
          if (t < 1) requestAnimationFrame(tick);
          else el.textContent = text;
        };
        requestAnimationFrame(tick);
      });
    },
    { threshold: 0.5 }
  );
  document.querySelectorAll('.figure').forEach(function (el) {
    counters.observe(el);
  });

  var nav = document.querySelector('.nav');
  var onScroll = function () {
    if (nav) nav.classList.toggle('is-stuck', window.scrollY > 12);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
